<template>
    <ais-instant-search :search-client="searchClient" :index-name="index" :initial-ui-state="initialUiState">

        <ais-refinement-list attribute="active_field_audits" v-show="false" />

        <!-- Filters -->
        <div class="px-3 py-3 filters float-right">

            <!-- By anything or Word -->
            <ais-search-box autofocus placeholder="Search Field Audits..."
                            :class-names="{'ais-SearchBox-input': 'form-control', 'ais-SearchBox-form':'form-group form-search pr-3'}">
            </ais-search-box>

        </div>

        <!-- Results -->
        <ais-hits>
            <table class="table table-striped table-hover mb-3" slot-scope="{ items }">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Trigger</th>
                    <th>Technician</th>
                    <th class="text-center">Project Trigger</th>
                    <th class="text-center">Completed Projects</th>
                    <th>Created At</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="field_audit in items"
                    :key="field_audit.id"
                    @click="redirectTo(`/field-audits/${field_audit.number}`)"
                    style="height: 60px">

                    <td v-text="field_audit.number"></td>
                    <td>
                        <div v-text="field_audit.trigger"></div>
                    </td>
                    <td>
                        <div class="name" v-text="field_audit.technician.name"></div>
                        <div class="text-info text-sm" v-if="field_audit.employer && field_audit.technician.id != field_audit.employer.id" v-text="field_audit.employer.name"></div>
                        <div class="text-danger text-sm" v-if="!field_audit.employer">No Employer Assigned</div>
                    </td>
                    <td class="text-center"
                        :class="{ 'text-danger' : (field_audit.technician.completed_projects_count >= field_audit.project_number) }"
                        v-text="field_audit.project_number">
                    </td>
                    <td class="text-center" v-text="field_audit.technician.completed_projects_count"></td>
                    <td v-text="shortDate(field_audit.created_at)"></td>
                </tr>
                </tbody>
            </table>
        </ais-hits>

        <!-- Pagination -->
        <ais-pagination />

    </ais-instant-search>
</template>
<script>
    import algoliasearch from "algoliasearch/lite";
    export default {
        data() {
            return {
                index: process.env.MIX_SCOUT_PREFIX + 'field_audits',
                searchClient: null,
                initialUiState: {},
            }
        },

        created() {
            let key = process.env.MIX_ALGOLIA_APP_ID;
            var secret = process.env.MIX_ALGOLIA_SECRET;

            let enviroment = this.index;
            this.initialUiState[`${enviroment}`] = {
                refinementList: {
                    active_field_audits: ["inactive"]
                },
            }

            this.searchClient = algoliasearch(key, secret)
        }

    }
</script>
<style scoped>
    @import 'https://cdn.jsdelivr.net/npm/instantsearch.css@7/themes/algolia-min.css';
    .filters {
        display: flex;
        align-items: center;
        margin-left: auto !important;
    }
</style>
